<template>
  <el-card>
    <ranking-filter class="chartstyle" :showfilter.sync="showFilter" v-show="showFilter"
                    @filtroAplicado="filter"></ranking-filter>
    <div v-show="!showFilter">
      <el-row>
        <el-col>
          <table class="tabela-ranking" v-loading="isLoading">
            <thead>
            <tr class="tabela-head-linha">
              <th class="tabela-head" colspan="5">
                <el-row>
                  <el-col :span="20"> Ranking {{title}}</el-col>
                  <el-col :span="4">
                    <filter-button :showfilter.sync="showFilter"></filter-button>
                  </el-col>
                </el-row>
              </th>
            </tr>
            </thead>
            <tbody>
            <tr class="tabela-body-linha" v-for="centro in centroCustos">
              <td class="tabela-posicao" style="color: #212121; font-weight: bold">{{centro.posicao}}</td>
              <td class="tabela-centrocusto">
                <strong class="tabela-centrocusto-nome" itemprop="name">{{centro.nome}}</strong></td>
              <td class="tabela-variacao">
                <icon-posicao :atual="centro.posicao" :anterior="centro.posicaoAnterior"></icon-posicao>
              </td>
              <td class="tabela-composicao">
                <div class="progress" style="height: 2em">
                  <barra-progresso v-for="node in centro.composicao"
                                   :valor="node.valor"
                                   :nome="node.nome"
                                   :percentual="node.percentual"
                                   :key="node.id"
                                   :color="getColor(node.id)">
                  </barra-progresso>
                </div>
              </td>
              <td class="tabela-total">
                <span class="tabela-total-value">
                   <span :class="{ 'meta-bateu': centro.bateu , 'meta-nao-bateu' : ! centro.bateu} ">
                        {{ formataNumero(centro.total) }}
                   </span>
              </span>
              </td>
            </tr>
            </tbody>
          </table>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <div class="legenda">
          <span class="badge  badge-dark" v-for="item in pilaresList" :key="item.id"
                :style="{backgroundColor: item.cor}">{{item.nome}}</span>
          </div>
        </el-col>
      </el-row>

    </div>
  </el-card>
</template>

<script>
  import IconPosicao from "./IconPosicao";
  import BarraProgresso from "./BarraProgresso";
  import {mapState} from 'vuex'
  import numeral from 'numeral'
  import locales from 'numeral/locales';
  import RankingFilter from "./RankingFilter";
  import FilterButton from "@/components/shared/FilterButton";
  import {trataErrors} from "@/domain/utils";


  export default {
    name: "Index",
    components: {FilterButton, RankingFilter, BarraProgresso, IconPosicao},
    data() {
      return {
        showFilter: false,
        isLoading: false,
        title: '',
        cores: [
          '#4DB079',
          '#4E0BA5',
          '#418F7D',
          '#2E86DA',
          '#FFC8B6',
          '#FF8600'
        ],
        centroCustos: [],
        pilaresList: []
      }
    },
    computed: {
      ...mapState(['centroCustoList', 'indicadorList', 'anoSelected', 'mesSelected', 'centroCustoSelected']),
      pilarCollect() {
        return collect(this.pilaresList);
      }
    },
    methods: {
      async filter(event) {
        try {
          numeral.locale('pt-br');
          this.isLoading = true
          let url = `${process.env.API_PATH}/ranking/centrocusto/${event.centroCusto}/${event.ano}`
          if (event.hasOwnProperty('mes')) {
            url = url + `/${event.mes}`
          }
          let {data} = await axios.get(url)
          this.title = data.title
          this.pilaresList = [...data.pilares]
          this.centroCustos = this.adicionaLabelsAoRanking([...data.ranking],
            [...this.centroCustoList],
            [...data.pilares])
        } catch (error) {
          trataErrors(error)
        } finally {
          this.isLoading = false
        }
      },
      formataNumero(valor) {
        return numeral(Number(valor)).format('0.00')
      },
      adicionaLabelsAoRanking(ranking, centroCustos, legendas) {
        const legendasByKey = collect(legendas).keyBy('id').all()
        const centroCustoList = collect(centroCustos).keyBy('id').all()
        return collect(ranking).map(centro => {
          centro.nome = centroCustoList.hasOwnProperty(centro.id) ? centroCustoList[centro.id].nome : ''
          centro.composicao = centro.composicao.map(item => {
            item.nome = legendasByKey.hasOwnProperty(item.id) ? legendasByKey[item.id].nome : ''
            return item
          })
          return centro
        }).all()
      },
      getColor(id) {
        let node = this.pilarCollect.where('id', id).first()
        if (node) return node.cor
        return "#000000"
      }
    },
    async mounted() {
      const event = {ano: this.anoSelected, centroCusto: 1}
      this.filter(event)
    }
  }
</script>

<style scoped>
  .meta-nao-bateu {
    color: #ef5350;
  }

  .meta-bateu {
    color: #2e7d32cd;
  }

  .progress {
    font-weight: bold;
  }

  .legenda {
    margin-top: 2em;
  }

  .legenda span {
    padding: .5em;
    margin: .3em;
  }

  .tabela-posicao {
    width: 3%;
  }

  .tabela-centrocusto {
    width: 15%;
  }

  .tabela-variacao {
    width: 3%;
  }

  .tabela-composicao {
    width: 74%;
  }

  .tabela-total {
    text-align: right;
    width: 5%;
  }

  .tabela-ranking {
    width: 100%;
  }

  .tabela-head-linha {
    border-bottom: solid 1px #ddd;
    height: 3em;
    font-size: 1.5em;
  }

  .tabela-body-linha {
    border-bottom: solid 1px #ddd;
    height: 3em;
  }

  .tabela-centrocusto-nome {
    font-weight: bold;
    color: #2E2E2E;
  }

  .tabela-total-value {
    font-weight: bold;
    text-align: right;
    color: #2E2E2E;
  }
</style>



// WEBPACK FOOTER //
// src/features/Dashboard/Components/Ranking/index.vue